import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Subscription, zip, Subject, takeUntil } from 'rxjs';
import { GeneralService } from 'src/app/services/general.service';
import { VendorService } from 'src/app/services/Vendor.service';
import { EACHCheckResultCode, EActionTypes, EPaymentGateway, EToaster, EUserSecurityFunctionID } from 'src/app/Shared/enum';
import { LoaderComponent } from 'src/app/Shared/loader/loader.component';
import { IUserPermissionHandler } from 'src/app/Shared/model/CommonModel';
import { ANGULAR_MODULES, SYNCFUSION_MODULES } from 'src/app/Shared/shared-imports';
import { UserPermissionHandlerDirective } from 'src/app/Shared/userPermissionHandler.directive';
import { WordReplacePipe } from 'src/app/Shared/word-replace.pipe';
import { OpsContactPerson } from '../ops-contact-person/ops-contact-person';
import { ZipCodePipe } from 'src/app/Shared/zip-code.pipe';
import { PhoneFormatPipe } from 'src/app/Shared/phone-format.pipe';
import Swal from 'sweetalert2';
import { SharedHTMLSettingsDataService } from 'src/app/Shared/sharedHTMLSettingsData.service';
import { IVendorACHDetails } from 'src/app/Shared/model/VendorsModel';
import { PaymentService } from 'src/app/services/payment.service';
import { OpsWebInquirySettings } from '../ops-web-inquiry-settings/ops-web-inquiry-settings';
import { VendorSettingService } from 'src/app/services/VendorSetting.service';
import { IVendorFormGeneralSettings } from 'src/app/Shared/model/SettingsModel';

@Component({
  selector: 'app-ops-vendor-info',
  imports: [ANGULAR_MODULES, SYNCFUSION_MODULES, WordReplacePipe, LoaderComponent, UserPermissionHandlerDirective, OpsContactPerson, ZipCodePipe, PhoneFormatPipe, OpsWebInquirySettings],
  standalone: true,
  templateUrl: './ops-vendor-info.html',
  styleUrl: './ops-vendor-info.scss'
})
export class OpsVendorInfo {

  vendorProducts = [
    { product: '', category: '', primary: false }
  ];
  loaderIcon: Promise<boolean>;
  private subscriptions: Subscription[] = [];
  toasterConfig = {
    closeButton: true,
    timeOut: 4500,
    easing: 'ease-out',
    progressBar: true,
    positionClass: 'toast-top-right',
    tapToDismiss: true,
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'slideUp'
  };
  response;
  vendorInfo;
  @Input() vendorId;
  timestamp = new Date().getTime();
  @Output() ChangeView = new EventEmitter<boolean>();
  disContactPerson: boolean = false;
  disWebInquirySettings: boolean = false;
  editPermissionHandlerData: IUserPermissionHandler = { FunctionId: EUserSecurityFunctionID['Vendor'], Action: EActionTypes.EDIT };
  vendorRoutingNo: string = '';
  vendorAccountNo: string = '';
  vendorAccountHolderName: string = '';
  vendorAccountType = null;
  vendorEnableACHAutoPay: boolean = false;
  private destroy$ = new Subject<void>();
  accounTypesACH = [{ Id: 1, Name: 'Savings' }, { Id: 2, Name: 'Checking' }];
  achSettingPaymentGateway;
  enableACH = false;
  newVendorId: string = '';
  viewPermissionHandlerData: IUserPermissionHandler = { FunctionId: EUserSecurityFunctionID.VendorACH, Action: EActionTypes.VIEW };
  createPermissionHandlerData: IUserPermissionHandler = { FunctionId: EUserSecurityFunctionID.VendorACH, Action: EActionTypes.CREATE };
  deletePermissionHandlerData: IUserPermissionHandler = { FunctionId: EUserSecurityFunctionID.VendorACH, Action: EActionTypes.DELETE };

  VendorGeneralSetting: IVendorFormGeneralSettings = {} as IVendorFormGeneralSettings;

  constructor(
    private toastr: ToastrService,
    private vendorService: VendorService,
    private sharedHTMLSettings: SharedHTMLSettingsDataService,
    private vendorSettingService: VendorSettingService,
    private paymentService: PaymentService) {
  }

  ngOnInit(): void {
    this.getVendorInfo();
    this.getVendorGeneralSettings();
    this.getCredentials();
  }

  getVendorInfo() {
    this.loaderIcon = Promise.resolve(true);
    this.subscriptions.push(this.vendorService.GetVendorInfoDetails(this.vendorId).subscribe((res: any) => {
      if (!res) {
        this.toastr.error($localize`Something went wrong`, $localize`Failed`, this.toasterConfig);
        this.loaderIcon = Promise.resolve(false);
        return;
      }
      const result = res;
      this.vendorInfo = {
        VendorId: result.VendorId,
        MarketVendorId: result.MarketVendorId,
        VendorName: result.VendorName,
        State: result.State,
        Email: result.Email,
        City: result.City,
        WorkPhone: result.WorkPhone,
        TelePhone: result.TelePhone,
        VendorProfile: result.VendorProfile ?? "",
        CellPhone: result.CellPhone ?? "",
        VendorType: result.VendorType == "P" ? "Permanent" : "Temporary",
        FirstName: result.FirstName,
        MiddleName: result.MiddleName,
        LastName: result.LastName,
        Company: result.Company,
        Address: result.Address,
        ZipCode: result.ZipCode,
        Country: result.Country,
        DLno: result.DLno,
        DLExpiryDate: this.getValidDate(result.DLExpiryDate),
        DLState: result.DLState,

        FacebookID: result.FacebookID,
        TwitterID: result.TwitterID,
        LinkedInID: result.LinkedInID,
        InstagramID: result.InstagramID,
        MarketId: result.MarketId,
        AchRoutingNo: result.AchRoutingNo,
        AchAccountNo: result.AchAccountNo,
        AchAccountHolderName: result.AchAccountHolderName,
        AchChecking: result.AchChecking,
        AchAutopay: result.AchAutopay,
        AchACHAccountToken: result.AchACHAccountToken
      };
      this.vendorProducts = !this.isNullOrEmpty(result.VendorProducts) ? result.VendorProducts.map(x => ({
        product: x.ProductName,
        category: x.ProductCategory,
        primary: x.Priority
      })) : [];

      this.loaderIcon = Promise.resolve(false);
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    }));
  }

  isNullOrEmpty(value) {
    return value === null || value === undefined || value === "";
  }

  UpdateVendor() {
    this.ChangeView.emit(true);
  }

  onBeforeOpen(args: any): void {
    if (!args || !args.target || !args.target.dataset || !args.target.dataset.content) {
      args.cancel = true;
    }
  }

  getValidDate(date: any): Date | null {
    if (!date || date.includes('1900')) {
      return null;
    }

    const [year, month, day] = date.substring(0, 10).split('-').map(Number);

    return new Date(year, month - 1, day);
  }


  contactPerson() {
    this.disContactPerson = true;
  }

  onCloseContactPerson() {
    this.disContactPerson = false;
  }

  wiSettings() {
    const hasEmail = !!this.vendorInfo?.Email?.trim();

    if (!hasEmail) {
      this.toastr.error(
        $localize`Vendor email is required to access Web Inquiry login settings.`,
        $localize`Error`,
        this.sharedHTMLSettings.ToasterConfig
      );
      return;
    }
    this.disWebInquirySettings = true;
  }

  onCloseWISettings() {
    this.disWebInquirySettings = false;
  }

  openChangeVendorIdModal() {
    this.newVendorId = '';
    this.sharedHTMLSettings.openModalById('modalChangeVendorId');
  }

  closeModalById(modalId) {
    this.sharedHTMLSettings.closeModalById(modalId);
  }

  saveChangeVendorId() {
    const newId = this.newVendorId?.trim();
    if (!newId) {
      this.toastr.warning($localize`Please enter a new Vendor ID`, $localize`Warning`, this.toasterConfig);
      return;
    }
    this.loaderIcon = Promise.resolve(true);
    this.vendorService.changeMarketVendorId(this.vendorInfo.MarketVendorId, newId).subscribe({
      next: (res) => {
        this.loaderIcon = Promise.resolve(false);
        if (res?.Success) {
          this.vendorInfo.MarketVendorId = newId;
          this.toastr.success(res.Message, $localize`Success`, this.toasterConfig);
          this.sharedHTMLSettings.closeModalById('modalChangeVendorId');
        } else {
          this.toastr.error(res?.Message || $localize`Failed to change Vendor ID`, $localize`Error`, this.toasterConfig);
        }
      },
      error: () => {
        this.loaderIcon = Promise.resolve(false);
        this.toastr.error($localize`Failed to change Vendor ID`, $localize`Error`, this.toasterConfig);
        this.sharedHTMLSettings.closeModalById('modalChangeVendorId');
      }
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      if (subscription) {
        subscription.unsubscribe();
      }
    });
    this.destroy$.next();
    this.destroy$.complete();
  }

  clickACHBtn() {
    this.vendorRoutingNo = this.vendorInfo.AchRoutingNo ?? '';
    this.vendorAccountNo = this.vendorInfo.AchAccountNo ?? '';
    this.vendorAccountHolderName = this.vendorInfo.AchAccountHolderName ?? '';
    this.vendorAccountType = this.vendorInfo.AchChecking ?? null;
    this.vendorEnableACHAutoPay = this.vendorInfo.AchAutopay ?? false;
  }

  disableSaveAch(): boolean {
    let errorSubjectList = [null, 'null', undefined, ''];
    if (errorSubjectList.includes(this.vendorRoutingNo) || errorSubjectList.includes(this.vendorAccountNo) || errorSubjectList.includes(this.vendorAccountHolderName) ||
      errorSubjectList.includes(this.vendorAccountType)) {
      return true;
    }
    return false;
  }

  createVendorACHToken(): void {
    Swal.fire({
      title: $localize`:@@Confirm:Confirm`,
      text: $localize`:@@ConfirmSaveVendorACHDetails:Are you sure you want to create Vendor ACH Token?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: $localize`:@@Yes:Yes`,
      cancelButtonText: $localize`:@@No:No`
    }).then((result) => {
      if (result.isConfirmed) {
        this.createACHAlias();
      }
    });
  }

  getCredentials() {
    this.paymentService.getCCCredentials().subscribe((res) => {
      if (res !== null) {
        this.enableACH = res.EnableACH;
        if (EPaymentGateway.OpenEdgeExpress == res.PaymentGateWay) {
          this.achSettingPaymentGateway = res.GatewayDetails ? JSON.parse(res.GatewayDetails) : null;
        }
      }
    })
  }

  createACHAlias() {
    if (this.achSettingPaymentGateway) {
      this.loaderIcon = Promise.resolve(true);
      let countyCode = 840; //124 : canada, 840 : US
      var aliaseRequest = "<REQUEST>" +
        "<XWEBID>" + this.achSettingPaymentGateway.XWEBID + "</XWEBID>" +
        "<XWEBTERMINALID>" + this.achSettingPaymentGateway.XWEBTERMINALID + "</XWEBTERMINALID>" +
        "<XWEBAUTHKEY>" + this.achSettingPaymentGateway.XWEBAUTHKEY + "</XWEBAUTHKEY>" +
        "<TRANSACTIONTYPE>CHECKALIASCREATE</TRANSACTIONTYPE>" +
        "<ACCOUNTNUMBER>" + this.vendorAccountNo + "</ACCOUNTNUMBER>" +
        "<ROUTINGNUMBER>" + this.vendorRoutingNo + "</ROUTINGNUMBER>" +
        "<NAMEONACCOUNT>" + this.vendorAccountHolderName + "</NAMEONACCOUNT>" +
        "<CREATECHECKALIAS>TRUE</CREATECHECKALIAS>" +
        "<BILLINGCOUNTRYCODE>" + countyCode + "</BILLINGCOUNTRYCODE>" +
        "</REQUEST>";
      this.paymentService.getCNPService(this.achSettingPaymentGateway.QueryPaymentStatusURL, aliaseRequest).subscribe((res: any) => {
        if (res) {
          this.loaderIcon = Promise.resolve(false);
          const jsonResp = JSON.parse(res);
          if (jsonResp.RESULT.RESPONSECODE == EACHCheckResultCode.Alias_Success && jsonResp.RESULT.RESPONSEDESCRIPTION == "Alias Success: Created") {
            this.updateACHToken(jsonResp.RESULT.ALIAS, 2);
            this.toastr.success(EToaster.MsgSuccessCreate + $localize`:@@VendorACHToken:Vendor ACH Token`, EToaster.TitleSuccess, this.sharedHTMLSettings.ToasterConfig);
            this.vendorInfo.AchACHAccountToken = jsonResp.RESULT.ALIAS;
          } else {
            this.toastr.error(EToaster.MsgErrorCreate + $localize`:@@VendorACHToken:Vendor ACH Token` + jsonResp.RESULT.RESPONSEDESCRIPTION, EToaster.TitleError, this.sharedHTMLSettings.ToasterConfig);
          }
        }
      }, err => {
        this.toastr.error(EToaster.MsgErrorCreate + $localize`:@@VendorACHToken:Vendor ACH Token`, EToaster.TitleError, this.sharedHTMLSettings.ToasterConfig);
        this.loaderIcon = Promise.resolve(false);
      }
      );
    } else {
      this.toastr.warning($localize`:@@MarketACHSettingsNotConfigured:Please ask Administrator to configure Market ACH Settings`, 'Settings required', this.toasterConfig);
      this.loaderIcon = Promise.resolve(false);
    }
  }

  verifyACHAlias() {
    if (this.achSettingPaymentGateway) {
      this.loaderIcon = Promise.resolve(true);
      var aliaseRequest = "<REQUEST>" +
        "<XWEBID>" + this.achSettingPaymentGateway.XWEBID + "</XWEBID>" +
        "<XWEBTERMINALID>" + this.achSettingPaymentGateway.XWEBTERMINALID + "</XWEBTERMINALID>" +
        "<XWEBAUTHKEY>" + this.achSettingPaymentGateway.XWEBAUTHKEY + "</XWEBAUTHKEY>" +
        "<TRANSACTIONTYPE>CHECKALIASLOOKUP</TRANSACTIONTYPE>" +
        "<ALIAS>" + this.vendorInfo.AchACHAccountToken + "</ALIAS>" +
        "</REQUEST>";
      this.paymentService.getCNPService(this.achSettingPaymentGateway.QueryPaymentStatusURL, aliaseRequest).subscribe((res: any) => {
        if (res) {
          this.loaderIcon = Promise.resolve(false);
          const jsonResp = JSON.parse(res);
          if (jsonResp.RESULT.RESPONSECODE == EACHCheckResultCode.Alias_Success && jsonResp.RESULT.RESPONSEDESCRIPTION == "Alias Success: Looked Up") {
            this.toastr.success(EToaster.MsgSuccessVerify + $localize`:@@VendorACHToken:Vendor ACH Token`, EToaster.TitleSuccess, this.sharedHTMLSettings.ToasterConfig);
          } else {
            this.toastr.error(EToaster.MsgErrorVerify + $localize`:@@VendorACHToken:Vendor ACH Token` + jsonResp.RESULT.RESPONSEDESCRIPTION, EToaster.TitleError, this.sharedHTMLSettings.ToasterConfig);
          }
        }
      }, err => {
        this.toastr.error(EToaster.MsgErrorVerify + $localize`:@@VendorACHToken:Vendor ACH Token`, EToaster.TitleError, this.sharedHTMLSettings.ToasterConfig);
        this.loaderIcon = Promise.resolve(false);
      }
      );
    } else {
      this.toastr.warning($localize`:@@MarketACHSettingsNotConfigured:Please ask Administrator to configure Market ACH Settings`, 'Settings required', this.toasterConfig);
      this.loaderIcon = Promise.resolve(false);
    }
  }

  deleteACHAlias() {
    Swal.fire({
      title: $localize`:@@Confirm:Confirm`,
      text: $localize`:@@ConfirmDeleteVendorACHToken:Are you sure you want to delete Vendor Token?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: $localize`:@@Yes:Yes`,
      cancelButtonText: $localize`:@@No:No`
    }).then((result) => {
      if (result.isConfirmed) {
        if (this.achSettingPaymentGateway) {
          this.loaderIcon = Promise.resolve(true);
          var aliaseRequest = "<REQUEST>" +
            "<XWEBID>" + this.achSettingPaymentGateway.XWEBID + "</XWEBID>" +
            "<XWEBTERMINALID>" + this.achSettingPaymentGateway.XWEBTERMINALID + "</XWEBTERMINALID>" +
            "<XWEBAUTHKEY>" + this.achSettingPaymentGateway.XWEBAUTHKEY + "</XWEBAUTHKEY>" +
            "<TRANSACTIONTYPE>CHECKALIASDELETE</TRANSACTIONTYPE>" +
            "<ALIAS>" + this.vendorInfo.AchACHAccountToken + "</ALIAS>" +
            "</REQUEST>";
          this.paymentService.getCNPService(this.achSettingPaymentGateway.QueryPaymentStatusURL, aliaseRequest).subscribe((res: any) => {
            if (res) {
              this.loaderIcon = Promise.resolve(false);
              const jsonResp = JSON.parse(res);
              if (jsonResp.RESULT.RESPONSECODE == EACHCheckResultCode.Alias_Success && jsonResp.RESULT.RESPONSEDESCRIPTION == "Alias Success: Deleted") {
                this.clearToken();
                this.updateACHToken(jsonResp.RESULT.ALIAS, 3);
                this.toastr.success(EToaster.MsgSuccessDelete + $localize`:@@VendorACHToken:Vendor ACH Token`, EToaster.TitleSuccess, this.sharedHTMLSettings.ToasterConfig);
              } else {
                this.toastr.error(EToaster.MsgErrorDelete + $localize`:@@VendorACHToken:Vendor ACH Token` + jsonResp.RESULT.RESPONSEDESCRIPTION, EToaster.TitleError, this.sharedHTMLSettings.ToasterConfig);
              }
            }
          }, err => {
            this.toastr.error(EToaster.MsgErrorDelete + $localize`:@@VendorACHToken:Vendor ACH Token`, EToaster.TitleError, this.sharedHTMLSettings.ToasterConfig);
            this.loaderIcon = Promise.resolve(false);
          }
          );
        } else {
          this.toastr.warning($localize`:@@MarketACHSettingsNotConfigured:Please ask Administrator to configure Market ACH Settings`, 'Settings required', this.toasterConfig);
          this.loaderIcon = Promise.resolve(false);
        }
      }
    });
  }

  clearToken() {
    this.vendorInfo.AchACHAccountToken = null;
  }

  updateACHToken(token: string, action: 2 | 3) {
    this.loaderIcon = Promise.resolve(true);
    const saveModel: IVendorACHDetails = {
      VendorId: this.vendorInfo.VendorId,
      AchRoutingNo: this.vendorRoutingNo.trim(),
      AchAccountNo: this.vendorAccountNo.trim(),
      AchAccountHolderName: this.vendorAccountHolderName.trim(),
      AchChecking: this.vendorAccountType,
      AchAutopay: this.vendorEnableACHAutoPay,
      ACHToken: token,
      Action: action
    };
    this.saveVendorACHDetails(saveModel);
  }

  isEditAndKeyDetailsModified() {
    let errorSubjectList = [null, 'null', undefined, ''];
    if ((this.vendorAccountHolderName != this.vendorInfo.AchAccountHolderName && !errorSubjectList.includes(this.vendorAccountHolderName)) ||
      (this.vendorAccountNo != this.vendorInfo.AchAccountNo && !errorSubjectList.includes(this.vendorAccountNo)) ||
      (this.vendorRoutingNo != this.vendorInfo.AchRoutingNo && !errorSubjectList.includes(this.vendorRoutingNo)) ||
      (this.vendorAccountType != this.vendorInfo.AchChecking && !errorSubjectList.includes(this.vendorAccountType))) {
      return true;
    }
    return false;
  }

  saveACHVendorDetails(): void {
    if (this.isEditAndKeyDetailsModified() && this.vendorInfo.AchACHAccountToken) {
      Swal.fire({
        title: $localize`Warning`,
        text: $localize`:@@validation1SaveVendorACH:Token already created. Please delete token and create new to update the ACH Account Number, Routing Number, Account Type and Account Holder Name`,
        icon: "info",
        confirmButtonText: $localize`Ok`,
      });
    } else {
      Swal.fire({
        title: $localize`:@@Confirm:Confirm`,
        text: $localize`:@@ConfirmSaveVendorACHDetails:Are you sure you want to save Vendor ACH details?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: $localize`:@@Yes:Yes`,
        cancelButtonText: $localize`:@@No:No`
      }).then((result) => {
        if (result.isConfirmed) {
          const saveModel: IVendorACHDetails = {
            VendorId: this.vendorInfo.VendorId,
            AchRoutingNo: this.vendorRoutingNo.trim(),
            AchAccountNo: this.vendorAccountNo.trim(),
            AchAccountHolderName: this.vendorAccountHolderName.trim(),
            AchChecking: this.vendorAccountType,
            AchAutopay: this.vendorEnableACHAutoPay,
            Action: 1
          };
          this.saveVendorACHDetails(saveModel);
        }
      });
    }
  }

  saveVendorACHDetails(saveModel: IVendorACHDetails) {
    this.loaderIcon = Promise.resolve(true);
    this.vendorService.UpdateVendorACHDetails(saveModel).pipe(takeUntil(this.destroy$)).subscribe({
      next: (response) => {
        this.loaderIcon = Promise.resolve(false);
        if (response.Success) {
          this.toastr.success(EToaster.MsgSuccessSave + $localize`:@@VendorACHDetails:Vendor ACH details`, EToaster.TitleSuccess, this.sharedHTMLSettings.ToasterConfig);
          if (saveModel.Action == 1 || saveModel.Action == 2) {
            this.vendorInfo.AchRoutingNo = saveModel.AchRoutingNo;
            this.vendorInfo.AchAccountNo = saveModel.AchAccountNo;
            this.vendorInfo.AchAccountHolderName = saveModel.AchAccountHolderName;
            this.vendorInfo.AchChecking = saveModel.AchChecking;
            this.vendorInfo.AchAutopay = saveModel.AchAutopay;
          }
        } else {
          this.toastr.error(EToaster.MsgErrorSave + $localize`:@@VendorACHDetails:Vendor ACH details`, EToaster.TitleError, this.sharedHTMLSettings.ToasterConfig);
        }
      },
      error: (error) => {
        this.loaderIcon = Promise.resolve(false);
        this.toastr.error(EToaster.MsgErrorSave + $localize`:@@VendorACHDetails:Vendor ACH details`, EToaster.TitleError, this.sharedHTMLSettings.ToasterConfig);
      },
    });
  }

  allowOnlyAlphaNumericVendorId(event: Event): void {
    const input = event.target as HTMLInputElement;
    const value = input.value.replace(/[^a-zA-Z0-9]/g, '');

    input.value = value;

  }

  getVendorGeneralSettings() {
    this.loaderIcon = Promise.resolve(true);

    this.subscriptions.push(
      this.vendorSettingService.getCurrentMarketVendorGeneralSettings().subscribe({
        next: (res: any) => {
          if (res) {
            this.VendorGeneralSetting = {
              IsVendorIdManual: res.SpecifyVendorID,
              DefaultProductEnabled: res.DefaultProductSelected,
              Product: res.ProductId,
              VendorNameFormat: res.VendorNamingConvention,
              VendorNameFormatId: res.VendorNamingConventionId,
              BoothTerm: res.BoothTerm,
              VendorAddressMandatory: res.VendAddressMandatory,
            };
          }

          this.loaderIcon = Promise.resolve(false);
        },
        error: (err) => {
          console.error('Failed to load vendor general settings.', err);
          this.loaderIcon = Promise.resolve(false);
        }
      })
    );
  }

}
